module.exports = __webpack_public_path__ + "static/awesome-5f359d5f4cead980abb2690c3c9829ed.png";